import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { X, Loader2, Send } from "lucide-react";

const CATS = ["Groupe", "Réseau", "Commerce", "RH", "Marketing", "Qualité", "Info", "Vie d'entreprise"];
const inp = "w-full px-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-[#1d4ed8] focus:ring-2 focus:ring-blue-100";

export default function ProposeNewsModal({ open, onClose }) {
  const [f, setF] = useState({ title: "", category: "Info", summary: "", body: "" });
  const [saving, setSaving] = useState(false);
  if (!open) return null;
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!f.title.trim()) return toast.error("Titre requis");
    setSaving(true);
    try {
      await api.post("/intranet-propose", f);
      toast.success("Merci ! Votre proposition a été transmise au service communication.");
      setF({ title: "", category: "Info", summary: "", body: "" }); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 grid place-items-center p-4" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg" data-testid="propose-news-modal">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <h3 className="font-bold text-slate-900">Proposer une actualité</h3>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-slate-100" data-testid="propose-news-close"><X className="w-4 h-4"/></button>
        </div>
        <div className="p-5 space-y-3">
          <input className={inp} placeholder="Titre de l'actualité" value={f.title} onChange={e => set("title", e.target.value)} data-testid="propose-news-title"/>
          <select className={inp} value={f.category} onChange={e => set("category", e.target.value)} data-testid="propose-news-category">{CATS.map(c => <option key={c}>{c}</option>)}</select>
          <input className={inp} placeholder="Résumé en une phrase" value={f.summary} onChange={e => set("summary", e.target.value)} data-testid="propose-news-summary"/>
          <textarea rows={5} className={inp} placeholder="Racontez-nous…" value={f.body} onChange={e => set("body", e.target.value)} data-testid="propose-news-body"/>
          <p className="text-xs text-slate-500">Votre proposition sera relue par le service communication avant publication.</p>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm font-semibold text-slate-600 hover:bg-slate-100">Annuler</button>
          <button onClick={submit} disabled={saving} data-testid="propose-news-submit" className="px-4 py-2 rounded-lg bg-[#1d4ed8] hover:bg-blue-800 text-white text-sm font-semibold flex items-center gap-1.5 disabled:opacity-60">
            {saving ? <Loader2 className="w-4 h-4 animate-spin"/> : <Send className="w-4 h-4"/>} Envoyer
          </button>
        </div>
      </div>
    </div>
  );
}
